import { theme } from "@local-logic/core/ui";
import { styled } from "styled-components";

export const SelectContainer = styled.div`
  width: 150px;
  display: flex;
  padding: ${theme["--ll-spacing-x-small"]} ${theme["--ll-spacing-medium"]}
    ${theme["--ll-spacing-xx-small"]} ${theme["--ll-spacing-medium"]};
`;

export const ScoresContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${theme["--ll-color-background"]};
  border: 1px solid ${theme["--ll-color-border"]};
`;
